import { buttonClassNames } from '@components/primitives/Button'
import Link from '@components/primitives/Link'
import { classMerge } from '@components/utilities/classMerge'

export default function BookADemoButton({
  className,
  demoUrl,
}: {
  className: string
  demoUrl: string
}) {
  return (
    <Link
      className={classMerge(buttonClassNames.outline.purple, className)}
      href={demoUrl}
      newTab
    >
      <p className='text-lg font-bold text-primary600'>Book a demo</p>
    </Link>
  )
}
